import React from 'react';
import './Skeleton.scss';

const Skeleton = ({
  width,
  height,
  variant = 'rectangular',
  animation = 'shimmer',
  className = '',
  style = {},
  count = 1,
  gap = 8,
}) => {
  const classes = [
    'skeleton',
    `skeleton--${variant}`,
    `skeleton--${animation}`,
    className,
  ].filter(Boolean).join(' ');

  const baseStyles = {
    width: width || (variant === 'circular' ? '40px' : '100%'),
    height: height || (variant === 'text' ? '1em' : '20px'),
    ...style,
  };

  if (count === 1) {
    return <div className={classes} style={baseStyles} />;
  }

  return (
    <div className="skeleton-group" style={{ gap: `${gap}px` }}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={classes} style={baseStyles} />
      ))}
    </div>
  );
};

export default Skeleton;